import * as React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';


import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import classifyPoint from "robust-point-in-polygon";


import leases from '../assets/map_layers/leases.json';
import planning from '../assets/map_layers/planning.json';
import leases_outline from '../assets/map_layers/leases_outlines.json';
import planning_outline from '../assets/map_layers/planning_outlines.json';

import { CircleLogo } from 'assets/icons/capacity_circles.js'



const { token_real, styles } = require('./config_map.json')
const capacity_fill = { 'red': '#f3a4b5', 'orange': '#f7ac9c', 'yellow': '#f8ecb1', 'green': '#b0f8d9', 'grey': '#8898aa' }
const capacity_outline = { 'red': '#b30000', 'orange': '#fb6340', 'yellow': '#ffd600', 'green': '#03cf77', 'grey': '#5e72e4' }


mapboxgl.accessToken = token_real;


export class Map extends React.Component {

    constructor(props) {
        super(props)
        this.mapContainer = React.createRef();
        this.state = {
            ...props.state,
            // capacities: null,
            // leases_outline: null,
            // map: null,
        }
        // this.setState = props.setState
    }

    componentDidMount() {

        console.log('leases', leases, this.state)


        const map = new mapboxgl.Map({
            id: 'map',
            container: this.mapContainer.current,
            style: "mapbox://styles/mapbox/light-v9",
            attributionControl: false,
            center: [this.state.lng, this.state.lat],
            zoom: this.state.zoom
        });

        let capacities = {}, winds = {}, outputs = {}, capacities_colors = {}, dirs = {};
        Object.entries(this.props.data).map(e => {
            console.log('MAP',e[0],e[1], Object.values(e[1])[Object.entries(e[1]).length - 1].capacity)
            let actuals = {}
            Object.entries(e[1]).map(val=>{if(val[1].actual) actuals[val[0]]=val[1]})
            // console.log('actuals',actuals)
            let obj = Object.values(actuals)[Object.entries(actuals).length - 1]
            var ii=2
            while(!obj.capacity){ //if the most recent "actual" is missing data
                obj = Object.values(actuals)[Object.entries(actuals).length - ii]
                ii+=1
            }
            const capacity = Math.round(obj.capacity*100)
            // console.log('capacity',capacity,e[0],e[0].slice(-4, 6),actuals[Object.keys(actuals)[0]].lease,actuals[Object.keys(actuals)[0]].lease.match(/\d{4}/))
            const lease_num = actuals[Object.keys(actuals)[0]].lease.match(/\d{4}/)

            if (capacity <= 100) capacities_colors[lease_num] = 'green'
            if (capacity <= 75) capacities_colors[lease_num] = 'yellow'
            if (capacity <= 50) capacities_colors[lease_num] = 'orange'
            if (capacity <= 25) capacities_colors[lease_num] = 'red'

            capacities[lease_num] = capacity
            winds[lease_num] = obj.wind
            outputs[lease_num] = obj.output
            dirs[lease_num] = obj.dir
            // console.log('capacities',lease_num,obj.output,e[0])
            // this.setState({capacities})
        })
        // let features = []
        // Object.entries(leases).map(e => {
        //     console.log(e)
        // })
        console.log('capacities',capacities,outputs)


        let features = []
        leases_outline.features.map(f => {
            let color = capacities_colors[f.properties.LEASE_NUMB.match(/\d{4}/)[0]]
            let capacity = capacities[f.properties.LEASE_NUMB.match(/\d{4}/)[0]]
            // if (color == undefined) color = 'grey'

            if(color!=undefined){
                features.push({
                    'type': "Feature",
                    'properties': { ...f.properties, fill: capacity_fill[color], outline: capacity_outline[color] },
                    'geometry': f.geometry
                })
            

                const el = document.createElement("svg");
                el.className = "marker";
                // ReactDOM.render(<CircleLogo map={map} size={70} value={capacity} color={capacity_outline[color]} />, el);
                createRoot(el).render(<CircleLogo map={map} size={70} value={capacity} color={capacity_outline[color]} />)
    
                new mapboxgl.Marker({ element: el })
                    .setLngLat([f.properties.centroid_lon, f.properties.centroid_lat])
                    .addTo(map);
            }
        })
        let leases_outline_update = { 'type': "FeatureCollection", 'crs': leases_outline.crs, 'features': features }

        features = []
        leases.features.map(f => {
            let color = capacities_colors[f.properties.LEASE_NUMB.match(/\d{4}/)[0]]
            // if (color == undefined) color = 'grey'

            if(color!=undefined){
                features.push({
                    'type': "Feature",
                    'properties': { ...f.properties, fill: capacity_fill[color], outline: capacity_outline[color] },
                    'geometry': f.geometry
                })
            }

        })
        let leases_update = { 'type': "FeatureCollection", 'features': features }

        // Create a popup, but don't add it to the map yet.
        const popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            backgroundColor: 'red',
            style: { backgroundColor: 'pink' }
        });


        map.once('load', async () => {
            // map.addSource('planning', {
            //     'type': 'geojson',
            //     'data': planning
            // })
            // map.addLayer({
            //     'id': 'planning',
            //     'type': 'fill',
            //     'source': 'planning',
            //     'paint': {
            //         'fill-color': '#2dce89',
            //         'fill-outline-color': '#07613a',
            //         'fill-opacity': 0.5
            //     }
            // })

            map.on('zoom', () => {
                // console.log(map.getZoom(), map.queryRenderedFeatures(), map.getContainer().getElementsByClassName('mapboxgl-marker'))
                Object.values(map.getContainer().getElementsByClassName('mapboxgl-marker')).map(e => {
                    const svgElement = e.children[0]
                    const percent = Math.max(Math.min(1 + (map.getZoom() - 8) * 0.4, 1), 0)
                    // console.log('percent', map.getZoom(), (map.getZoom() - 8), (map.getZoom() - 8) * 0.4, percent)
                    // console.log(e,e.children[0])
                    svgElement.style.transform = `scale(${percent})`;
                    e.style.transform = `scale(${percent})`;
                })

            })

            map.addSource('leases', {
                'type': 'geojson',
                'data': leases_update
            })
            map.addLayer({
                'id': 'leases',
                'type': 'fill',
                'source': 'leases',
                'paint': {
                    'fill-color': ['get', 'fill'],//'#f3a4b5',
                    'fill-outline-color': ['get', 'outline'],//'#f56483',
                    'fill-opacity': 1.0
                }
            })

            map.addSource('leases_outline', {
                'type': 'geojson',
                'data': leases_outline_update
            })
            map.addLayer({
                'id': 'leases_outline',
                'type': 'line',
                'source': 'leases_outline',
                'paint': {
                    'line-color': ['get', 'outline'],//#f56483',//'#f5365c',
                    'line-width': 3,
                    'line-blur': 1,

                }
            })
            // console.log(leases_outline, leases_outline_update)
            // map.getSource('leases_outline').setData(leases_outline_update)



            map.addSource('selectedArea', {
                'type': 'geojson',
                'data': null
            })
            map.addLayer({
                'id': 'selectedArea',
                'type': 'fill',
                'source': 'selectedArea',
                'layout': { 'visibility': 'none' },
                'paint': {
                    'fill-color': ['get', 'outline'],//'#f56483',
                    'fill-opacity': 0.5
                }
            })

            map.on('click', () => {
                map.setLayoutProperty('selectedArea', 'visibility', 'none')
            })


            map.on('click', 'leases', (e) => {
                // console.log(map.queryRenderedFeatures())
                console.log('leases', leases, e, Object.values(e.lngLat))
                Object.values(leases_outline_update.features).map(v => {
                    let coords;
                    if (v.geometry.type == "MultiPolygon") {
                        coords = []
                        v.geometry.coordinates.forEach(arr => {
                            coords = coords.concat(arr[0])
                        })

                    } else coords = v.geometry.coordinates[0]

                    if (classifyPoint(coords, Object.values(e.lngLat)) <= 0) {
                        // console.log("this one", v, v.geometry.coordinates)

                        map.getSource('selectedArea').setData({
                            'type': 'FeatureCollection',
                            'features': [{
                                'type': 'Feature',
                                'geometry': v.geometry,
                                'properties': v.properties
                            }]
                        });
                        map.setLayoutProperty('selectedArea', 'visibility', 'visible')
                    }
                })
                let features = null;
                map.queryRenderedFeatures(e.point).map((f) => {
                    // console.log('feat', f)
                    if (f.source == "leases") features = f
                })

                // console.log('features', features)
                const lease_num = features.properties.LEASE_NUMB.match(/\d{4}/)[0]
                const description = { 'area': this.state.max_cap[lease_num].proj, 'url1': features.properties.URL1, 'url2': features.properties.URL2 }
                this.props.setState({ ...this.props.state, description: description })
            })



            map.on('mouseenter', 'leases', (e) => {
                // console.log('leases mouse', e,this.state.max_cap)
                map.getCanvas().style.cursor = 'pointer';
                const coordinates = [e.features[0].properties['centroid_lon'], e.features[0].properties['centroid_lat']];
                const lease_num = e.features[0].properties.LEASE_NUMB.match(/\d{4}/)[0]
                const description = `<a><strong>${this.state.max_cap[lease_num].proj.toUpperCase()}</strong><a><br/><strong>Net Capacity: </strong>${capacities[lease_num]}%</a><br/><a><strong>Wind Speed: </strong>${winds[lease_num]} m/s</a><br/><a><strong>Wind Dir: </strong>${Math.round(dirs[lease_num])}º</a><br/><a><strong>Output: </strong>${outputs[lease_num]} / ${this.state.max_cap[lease_num].cap} MW</a>`;
                // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                //     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                // }
                popup.setLngLat(coordinates).setHTML(description).addTo(map);
            })
            map.on('mouseleave', 'leases', () => {
                map.getCanvas().style.cursor = '';
                popup.remove();
            });

            map.on('click', 'planning', (e) => {
                // console.log('planning', e)
                let features = null;
                map.queryRenderedFeatures(e.point).map((f) => {
                    // console.log('feat', f)
                    if (f.source == "planning") features = f
                })

                // console.log('features', features)
                const description = features.properties.ADDITIONAL
                this.props.setState({ ...this.state, description: description })

            })
        })
        // this.setState({ map: map })
        this.map = map

    }

    componentDidUpdate(prevProps, prevState) {


    }



    render() {

        return (

            <div style={{ height: '540px' }} ref={this.mapContainer} />

        )
    }
}

export default Map;

